import React , {useEffect, useState}  from "react";
// react plugin for creating charts
import ChartistGraph from "react-chartist";
// react plugin for creating vector maps
import { VectorMap } from "react-jvectormap";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import Icon from "@material-ui/core/Icon";

// @material-ui/icons
// import ContentCopy from "@material-ui/icons/ContentCopy";
import Store from "@material-ui/icons/Store";
// import InfoOutline from "@material-ui/icons/InfoOutline";
import Warning from "@material-ui/icons/Warning";
import DateRange from "@material-ui/icons/DateRange";
import LocalOffer from "@material-ui/icons/LocalOffer";
import Update from "@material-ui/icons/Update";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import AccessTime from "@material-ui/icons/AccessTime";
import Refresh from "@material-ui/icons/Refresh";
import Edit from "@material-ui/icons/Edit";
import Place from "@material-ui/icons/Place";
import ArtTrack from "@material-ui/icons/ArtTrack";
import Language from "@material-ui/icons/Language";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Table from "components/Table/Table.js";
import Button from "components/CustomButtons/Button.js";
import Danger from "components/Typography/Danger.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import axios from 'axios';
import { GoogleMap, LoadScript, Marker, InfoWindow } from '@react-google-maps/api';

import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import moment from 'moment';

import {useSelector, useDispatch} from 'react-redux'
import { Redirect } from "react-router-dom";

import {
  dailySalesChart,
  emailsSubscriptionChart,
  completedTasksChart
} from "variables/charts";

import styles from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";

import priceImage1 from "assets/img/card-2.jpeg";
import priceImage2 from "assets/img/card-3.jpeg";
import priceImage3 from "assets/img/card-1.jpeg";

const us_flag = require("assets/img/flags/US.png");
const de_flag = require("assets/img/flags/DE.png");
const au_flag = require("assets/img/flags/AU.png");
const gb_flag = require("assets/img/flags/GB.png");
const ro_flag = require("assets/img/flags/RO.png");
const br_flag = require("assets/img/flags/BR.png");

var mapData = {
  AU: 760,
  BR: 550,
  CA: 120,
  DE: 1300,
  FR: 540,
  GB: 690,
  GE: 200,
  IN: 200,
  RO: 600,
  RU: 300,
  US: 2920
};

const useStyles = makeStyles(styles);

export default function Dashboard() {

  const classes = useStyles();
  const [redirctTo, setRedirctTo] = useState(false);
  const [Users, setUsers] = useState([])
  const [Markers, setMarkers] = useState([])
  const [Properties, setProperties] = useState([])
  const [token_logged, settoken_logged] = React.useState("");

  const [info_show, setinfo_show] = useState(false)
  const [info_show_pos, setinfo_show_pos] = useState(false)

  const [datatable, setdatatable] = useState([])
  const [force_update, setforce_update] = useState(false); 
  const [center, setcenter] = useState(false); 

  const [forceRefresh, setforceRefresh] = React.useState(1);

  const [state, setState] = useState({
    start: moment().subtract(29, 'days'),
    end: moment(),
  });
  const { start, end } = state;
  const handleCallback = (start, end) => {
    console.log(start.format("YYYY-MM-DD HH:mm:ss"))
    console.log(end.format("YYYY-MM-DD HH:mm:ss"))
    setState({ start, end });

    var compareDate = moment("2021-10-18T10:05:33.987");
    console.log(compareDate.isBetween(start, end));

    set_data2(start,end)


  };
  const label =
    start.format('MMMM D, YYYY') + ' - ' + end.format('MMMM D, YYYY');
   
  useEffect(() => {

    document.getElementById("test_id").innerHTML = "Dashboard"; 
    
    const local_login = localStorage.getItem('local_login')
    let token = "";
    if(local_login){
      try {
        const getToken = async () => {
          const res = await axios.post('/user/refresh_token', null)
          
          token = res.data.access_token;

          settoken_logged(token);

          const res2 = await axios.get('/user/infor', {
            headers: {Authorization: token}
          })     

          const res3 = await axios.get('/codeset/all_reports', {
            headers: {Authorization: token}
          })  

          setUsers(res3.data)
          //setMarkers(res3.data)

          const res4 = await axios.get('/property/all_infor', {
            headers: {Authorization: token}
          })  

          //console.log(res4.data)

          setProperties(res4.data)

          set_data(res3.data,res4.data )
          
          
          
        }
        getToken()
      } catch (err) {
        setRedirctTo(true);
      } 
    }else{
      setRedirctTo(true)
    }
    
  
}, [  ]);


const set_data = (u,p) => {
  
  let datatable1 = [];
  let new_markers = [];

    for (let index = 0; index < p.length; index++) {

      let total_count = 0;

      for (let index2 = 0; index2 < u.length; index2++) {
          
          if(p[index]._id == u[index2].property_type_id ){
            let compareDate = moment(u[index2].createdAt);    
            if(compareDate.isBetween(moment().subtract(29, 'days'), moment())){
              total_count++;
              new_markers.push(u[index2]);
            }
          }
      }
      
      let percent = (total_count * 100) / u.length 
      percent = percent.toFixed(2)
      
      let user_item = [ "", p[index].name, total_count, percent +"%" ];

      

      datatable1.push(user_item);
      
    }

    console.log(datatable1);
    setMarkers(new_markers);
    
    setdatatable(datatable1)
    let center = {
      lat: 36.778259,
      lng: -119.417931
    };
    setcenter(center)

}

const set_data2 = (start,end) => {

   
  let new_markers = [];

  let datatable1 = [];

    for (let index = 0; index < Properties.length; index++) {

      let total_count = 0;

      for (let index2 = 0; index2 < Users.length; index2++) {
          
          if(Properties[index]._id == Users[index2].property_type_id ){
            let compareDate = moment(Users[index2].createdAt);    
            if(compareDate.isBetween(start, end)){
              total_count++;
              new_markers.push(Users[index2]);
            }
          }

      }
      
      let percent = (total_count * 100) / Users.length 
      percent = percent.toFixed(2)
      
      let user_item = [ "", Properties[index].name, total_count, percent +"%" ];

      
      datatable1.push(user_item);
      

      
      
    }

    console.log(datatable1);
    console.log(new_markers)
    setMarkers(new_markers);
    
    setdatatable(datatable1)
    let center = {
      lat: 36.778259,
      lng: -119.417931
    };
    setcenter(center)


}


  

if (redirctTo){
  return <Redirect to='/auth/login-page'  />
}

const containerStyle = {
  width: '100%',
  height: '400px'
};



const open_details = (key) => {
   console.log("ente here", key)
   let new_users = Markers;
   new_users[key].info_show = true;
   setMarkers(new_users);
   setcenter("")
   setforce_update(force_update => force_update + 1);
}

const close_details = (key) => {
  console.log("ente here", key)
  let new_users = Markers;
  new_users[key].info_show = false;
  setMarkers(new_users);
  setcenter("")
  setforce_update(force_update => force_update + 1);
}

 


  return (
    <div>
      
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="success" icon>
              <CardIcon color="success">
                <Language />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>
                
              </h4>
            </CardHeader>
            <CardBody>
              <GridContainer justify="space-between">
                <GridItem xs={12} sm={12} md={5}>
                  {(datatable.length > 0) && (
                  <Table
                    tableData={datatable
                    }
                  />
                  )}
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <LoadScript
                    googleMapsApiKey="AIzaSyBGkMG-nj0pgK1ruZRZUdLW-7SgSkmqQfQ"
                  >
                    <GoogleMap
                      key={forceRefresh}
                      mapContainerStyle={containerStyle}
                      center={center}
                      zoom={5}
                    >
                      
                      
                      { /* Child components, such as markers, info windows, etc. */ 
                      Markers.map((report,report_key) =>
                        <Marker  onClick={(e)=>open_details(report_key)}  label={report.name} position={{lat: parseFloat( report.latitude),  lng: parseFloat(report.longitude)}} >
                           {(report.info_show) && (
                            <InfoWindow onCloseClick={(e)=>close_details(report_key)}
                              position={{lat: parseFloat( report.latitude),  lng: parseFloat(report.longitude)}}
                            >
                              <div >
                                <a target="_blank" href={"https://arcorinc.herokuapp.com/admin/report/" + report._id }  >{report.report_name}</a>
                              </div>
                            </InfoWindow>
                            )}

                        </Marker>
                      )
                      
                      }
                      <></>
                    </GoogleMap>
                  </LoadScript>
                </GridItem>
                <GridItem xs={4} sm={4} md={4}>
                <DateRangePicker 
                  initialSettings={{
                    startDate: start.toDate(),
                    endDate: end.toDate(),
                    ranges: {
                      Today: [moment().toDate(), moment().toDate()],
                      Yesterday: [
                        moment().subtract(1, 'days').toDate(),
                        moment().subtract(1, 'days').toDate(),
                      ],
                      'Last 7 Days': [
                        moment().subtract(6, 'days').toDate(),
                        moment().toDate(),
                      ],
                      'Last 30 Days': [
                        moment().subtract(29, 'days').toDate(),
                        moment().toDate(),
                      ],
                      'This Month': [
                        moment().startOf('month').toDate(),
                        moment().endOf('month').toDate(),
                      ],
                      'Last Month': [
                        moment().subtract(1, 'month').startOf('month').toDate(),
                        moment().subtract(1, 'month').endOf('month').toDate(),
                      ],
                    },
                  }}
                  onCallback={handleCallback}
                >
                  <div
                    id="reportrange"
                    className="col-4"
                    style={{
                      background: '#fff',
                      cursor: 'pointer',
                      padding: '5px 10px',
                      border: '1px solid #ccc',
                      width: "300px",
                    }}
                  >
                    <i className="fa fa-calendar"></i>&nbsp;
                    <span>{label}</span> <i className="fa fa-caret-down"></i>
                  </div>
                </DateRangePicker>
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      
      
    </div>
  );
}
